<template>
  <div class="hello" id="footer">
     <footer>
         <div class="container ">
            <div class="row">
               <div class="col-md-4 col-sm-3">
                  <h3>Secure payments with</h3>
                  <p><img src="img/cards.png" alt="" class="img-responsive"></p>
                  <p>Note: * All Images are for visualisation</p>    
               </div>
               <div class="col-md-3 col-sm-3">
                  <h3>About</h3>
                  <ul class="ms-footer">
                     <li><router-link to='/about-us'>About us</router-link></li>
                     <li><router-link to="/contact-us">Contacts</router-link></li>
                     <li><router-link to="/privacy-policy">Privacy & Policy</router-link></li>
                  </ul>
               </div>
               <div class="col-md-4 col-sm-3"  id="newsletter">
                  <h3>Get Our Apps</h3>
                  <p style="margin-top: 25px">
                     <img src="/img/playstore.png" width="150" alt=""/>
                     <img src="/img/ios.png" width="150" alt="" class="pull-right"></p>
               </div>
               <div class="col-md-3 col-sm-3 hide"  id="newsletter">
                  <h3>Newsletter</h3>
                  <p>Join our newsletter to keep be informed about offers and news.</p>
                  <div id="message-newsletter_2"></div>
                  <form method="post" action="#0" name="newsletter_2" id="newsletter_2">
                     <div class="form-group">
                        <input name="email_newsletter_2" id="email_newsletter_2"  type="email" value=""  placeholder="Your mail" class="form-control">
                     </div>
                     <input type="button" value="Subscribe" class="btn_1" id="submit-newsletter_2">
                  </form>
               </div>
            </div>
            <div class="row">
               <div class="col-md-12">
                  <div id="social_footer">
                     <ul>
                        <li><a href="https://www.facebook.com/arturospizza/" target="_blank"><i class="icon-facebook"></i></a></li>
                        <!-- <li><a href="#0"><i class="icon-twitter"></i></a></li>
                        <li><a href="#0"><i class="icon-linkedin"></i></a></li>
                        <li><a href="#0"><i class="icon-instagram"></i></a></li> -->
                     </ul>
                     <p>© Arturos Pizza & Pasta | 2020 | Designed & Developed by <a href="https://www.supportsoft.com.au/" target="_blank">supportsoft</a> </p>
                  </div>
               </div>
            </div>
         </div>
     </footer>
  </div>  
</template>

<script>
export default {
  name: 'MainFooter',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
[class^="icon-"]:before {
    font-family: "fontello";
    font-style: normal;
    font-weight: 400;
    speak: none;
    display: inline-block;
    text-decoration: inherit;
    width: 1em;
    margin-right: .2em;
    text-align: center;
    font-variant: normal;
    text-transform: none;
    line-height: 2.1em;
    margin-left: .2em;
}
</style>
